var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import DataField from "./DataField.js";
class ObjectDataField extends DataField {
  static get prototypeProperties() {
    return {
      complexMapping: true
    };
  }
}
__publicField(ObjectDataField, "$name", "ObjectDataField");
__publicField(ObjectDataField, "type", "object");
__publicField(ObjectDataField, "dataConstructor", Object);
ObjectDataField.initClass();
ObjectDataField._$name = "ObjectDataField";
export {
  ObjectDataField as default
};
